<script lang="ts" setup>
  import { ref, toRefs } from 'vue';

  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin"

  const props = defineProps({
    content: String,
    inverted: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    linkTarget: {
      type: String,
      default: null,
    },
    linkMethod: {
      type: String,
      default: null,
    },
    submitForm: {
      type: Boolean,
      default: false,
    },
    useTheming: {
      type: Boolean,
      default: false,
    },
    useIncognitoTheming: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["main-action"]);

  const { inverted, filled, linkTarget, linkMethod, submitForm, useTheming, useIncognitoTheming } = toRefs(props);
  const root = ref<HTMLElement | null>(null);

  const buttonClick = () => {
      if (submitForm.value) {
        const form =  root.value?.closest('form');
        if(form) form.submit();
      } else {
        if (
          linkTarget.value &&
          (!linkMethod.value || linkMethod.value.toLowerCase() === "get")
        ) {
          window.location.href = linkTarget.value;
        } else if (linkTarget.value && linkMethod.value && linkMethod.value) {
          // Get CSRF-Token
          const metas = document.getElementsByTagName("meta");
          let token = null;
          for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute("name") === "csrf-token") {
              token = metas[i].getAttribute("content");
              break;
            }
          }

          // Create an setup form
          const form = document.createElement("form");
          form.action = linkTarget.value;
          form.method = "post";
          form.style.display = "none";

          // Smuggle in the method (because forms only can post)
          // so that rails understands we are doing a emulated "this.linkMethod"-call
          let input = document.createElement("input");
          input.type = "hidden";
          input.name = "_method";
          input.value = linkMethod.value.toLowerCase();
          form.appendChild(input);

          // Append authenticity token for CSRF protection
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "authenticity_token";
          if(token)
          input.value = token;
          form.appendChild(input);

          // Apend and send form
          document.body.appendChild(form);
          form.submit();
        } else {
          emit("main-action");
        }
      }
    };
    const cssClasses = () => {
      const result = [];

      // { inverted, filled, unthemed: !useTheming }

      if (inverted.value) {
        result.push("inverted");
      } else if (filled.value) {
        result.push("filled");
      }

      if (useTheming.value) {
        if (inverted.value) {
          result.push(themingCssClass("hover_main_color"));
        } else if (filled.value) {
          result.push(themingCssClass("border"));
          result.push(themingCssClass("inverted"));
          result.push(themingCssClass("hover_box"));
        } else {
          result.push(themingCssClass("border"));
          result.push(themingCssClass("normal"));
          result.push(themingCssClass("hover_invert"));
        }
      } else if(!useIncognitoTheming.value) {
        result.push("theming-not-used");
      }

      return result;
    };
</script>

<template>
  <div
    ref="root"
    v-on:click="buttonClick"
    class="components__simple-button center"
    v-bind:class="cssClasses()"
  >
    <div class="center">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "~stylesheets/frontend/variables/colors";

.components__simple-button {
  &.theming-not-used {
    color: colors.$color-green;
    border: 1px solid colors.$color-green;

    &:hover,
    &.filled {
      background-color: colors.$color-green;
      color: colors.$color-inverted;
    }

    &.filled {
      &:hover {
        box-shadow: 0 0 10px 0 rbga(colors.$color-green-rgb, 0.8);
      }
    }

    &.inverted {
      &:hover {
        color: colors.$color-green;
      }
    }
  }
}

.components__simple-button {
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 9px 30px;

  font-size: 18px;

  border-radius: 2px;

  cursor: pointer;
  user-select: none;

  &.center {
    text-align: center;
  }

  &.inverted {
    border: 1px solid colors.$color-inverted;
    color: colors.$color-inverted;

    &:hover {
      background-color: colors.$color-inverted;
    }
  }
}
</style>
